import React, {Component} from 'react';
import LineworxClient from './lineworxClient';
//import $ from 'jquery';
//import Cookies from 'universal-cookie';
import Navigation from './components/Navigation/Navigation';
//import { withRouter } from 'react-router'; 

// Import module css
import styles from './Header.module.css';

// function logout() {
//   sessionStorage.setItem('user', null);
//   const cookies = new Cookies();
//   cookies.remove("lineworx_token");
// }

// function Header() {
class Header extends Component {
    // constructor(props) {
    //     super(props);

    //     this.state={
    //         showMobileNav: false,
    //     }

    // // this.handleShowMobileNav = this.handleShowMobileNav.bind(this);
    // }


  // handleShowMobileNav() {
  //   this.setState({
  //     showMobileNav: !this.state.showMobileNav,
  //   })
  // }

  render() {
    
    if (window.location.pathname === '/login') return null;
    return LineworxClient.isLoggedIn() && (
      <header id="masthead" className={`site-header sticky-header ${styles.siteHeader}`} role="banner">
        <nav className={`navbar navbar-expand-md navbar-light justify-content-between ${styles.headerNavbar}`}>
          <a className={`navbar-brand animated fadeInLeft delay-1 ${styles.navbarBrand}`} href="/">
            <img src="/images/logo_w_words.png" className={`active-header-logo ${styles.navbarBrandLogo}`} alt="logo"/>
          </a>
          
          <Navigation />
        </nav>
      </header>
    )
  }
}

export default Header;
